module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('span', [_vm._v("[")]), (_vm.percentage) ? _c('span', [_vm._l((_vm.chunks), function(n) {
    return _c('span', [_vm._v("=")])
  }), _vm._l((_vm.missingChunks), function(n) {
    return _c('span', [_vm._v(" ")])
  })], 2) : _vm._e(), _c('span', [_vm._v("]")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c06d27f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progressBar.vue
// module id = 295
// module chunks = 2